export default __webpack_public_path__ + "308143c47d9e7bd41640a760b7d0fa03.png";